import Swal from "sweetalert2";

const SweetAlert = {
  // Basic Alert
  show: ({
    title = "",
    text = "",
    icon = "info",
    confirmButtonText = "OK",
    ...options
  }) => {
    return Swal.fire({
      title,
      text,
      icon,
      confirmButtonText,
      ...options,
    });
  },

  // Success
  success: (title, text = "", confirmButtonText = "OK") => {
    return Swal.fire({
      title,
      text,
      icon: "success",
      confirmButtonText,
    });
  },

  // Error
  error: (title, text = "", confirmButtonText = "OK") => {
    return Swal.fire({
      title,
      text,
      icon: "error",
      confirmButtonText,
    });
  },

  // Warning
  warning: (title, text = "", confirmButtonText = "OK") => {
    return Swal.fire({
      title,
      text,
      icon: "warning",
      confirmButtonText,
    });
  },

  // Info
  info: (title, text = "", confirmButtonText = "OK") => {
    return Swal.fire({
      title,
      text,
      icon: "info",
      confirmButtonText,
    });
  },

  // Question
  question: (title, text = "", confirmButtonText = "Yes") => {
    return Swal.fire({
      title,
      text,
      icon: "question",
      confirmButtonText,
    });
  },

  // Confirmation Dialog
  confirm: ({
    title = "Are you sure?",
    text = "",
    icon = "warning",
    confirmButtonText = "Yes",
    cancelButtonText = "Cancel",
  }) => {
    return Swal.fire({
      title,
      text,
      icon,
      showCancelButton: true,
      confirmButtonText,
      cancelButtonText,
      reverseButtons: true,
    });
  },

  // Toast Notification
  toast: ({
    title = "",
    icon = "success",
    timer = 3000,
    position = "top-end",
  }) => {
    return Swal.fire({
      toast: true,
      position,
      icon,
      title,
      showConfirmButton: false,
      timer,
      timerProgressBar: true,
    });
  },

  // Loading
  loading: (title = "Loading...") => {
    Swal.fire({
      title,
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });
  },

  // Close Loading
  close: () => {
    Swal.close();
  },

  // Custom Alert
  custom: (options) => {
    return Swal.fire(options);
  },
};

export default SweetAlert;


// //usage
// // import SweetAlert from "../components/SweetAlert";

// SweetAlert.success(
//   "Success!",
//   "Data saved successfully."
// );
// SweetAlert.error(
//     "Error!",
//     "Something went wrong."
//   );

//   SweetAlert.warning(
//     "Warning!",
//     "Please fill all required fields."
//   );
//   SweetAlert.info(
//     "Information",
//     "Your profile has been updated."
//   );
//   const result = await SweetAlert.confirm({
//     title: "Delete User?",
//     text: "You won't be able to recover this user.",
//   });
  
//   if (result.isConfirmed) {
//     // Delete user
//     SweetAlert.success("Deleted!", "User has been deleted.");
//   }
//   SweetAlert.toast({
//     title: "Saved Successfully",
//     icon: "success",
//   });
//   SweetAlert.toast({
//     title: "Login Failed",
//     icon: "error",
//     position: "bottom-end",
//   });
//   SweetAlert.loading("Uploading...");
//   //Close it after the API call:
//   SweetAlert.close();
//   //Custom Alert
//   SweetAlert.custom({
//     title: "Custom Alert",
//     html: "<b>This is custom HTML.</b>",
//     icon: "question",
//     showCancelButton: true,
//     confirmButtonText: "Continue",
//     cancelButtonText: "Cancel",
//   });
//   SweetAlert.show({
//     title: "Welcome",
//     text: "Login successful",
//     icon: "success",
//     confirmButtonText: "Continue",
//     footer: "<a href='#'>Need help?</a>",
//   });